import { useState } from "react";
import { Send } from "lucide-react";
import { SERVICES } from "./data";

const WA_NUMBER = "918696938848";

const inputCls =
  "w-full rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--bg))] px-4 py-3.5 text-base text-[hsl(var(--fg))] placeholder:text-[hsl(var(--muted))] outline-none transition-colors duration-300 focus:border-[hsl(var(--primary))]";

export const LeadForm = () => {
  const [form, setForm] = useState({ name: "", contact: "", service: "", message: "" });
  const [error, setError] = useState("");

  const set = (k) => (e) => {
    const v = e.target.value;
    setForm((prev) => ({ ...prev, [k]: v }));
    setError("");
  };

  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.contact.trim()) {
      setError("Please fill your name and contact details.");
      return;
    }
    setError("");
    const text = [
      "Hi Design4you! I'd like to start a project.",
      `Name: ${form.name}`,
      `Contact: ${form.contact}`,
      form.service && `Service: ${form.service}`,
      form.message && `Details: ${form.message}`,
    ]
      .filter(Boolean)
      .join("\n");
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`, "_blank");
  };

  return (
    <form
      onSubmit={submit}
      data-testid="lead-form"
      className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] p-6 md:p-8"
    >
      <p className="font-head text-2xl font-semibold">Tell us about your project</p>
      <p className="mt-1 text-sm text-[hsl(var(--muted))]">
        Fill this in — it opens WhatsApp with your details ready to send.
      </p>

      <div className="mt-6 grid gap-4">
        <input
          data-testid="lead-form-name"
          value={form.name}
          onChange={set("name")}
          placeholder="Your name *"
          className={inputCls}
        />
        <input
          data-testid="lead-form-contact"
          value={form.contact}
          onChange={set("contact")}
          placeholder="Phone or email *"
          className={inputCls}
        />
        <select
          data-testid="lead-form-service"
          value={form.service}
          onChange={set("service")}
          className={`${inputCls} appearance-none ${form.service ? "" : "text-[hsl(var(--muted))]"}`}
        >
          <option value="">What do you need?</option>
          {SERVICES.map((s) => (
            <option key={s.title} value={s.title}>
              {s.title}
            </option>
          ))}
          <option value="Something else">Something else</option>
        </select>
        <textarea
          data-testid="lead-form-message"
          value={form.message}
          onChange={set("message")}
          placeholder="A line or two about your project (optional)"
          rows={3}
          className={`${inputCls} resize-none`}
        />
      </div>

      {error && (
        <p data-testid="lead-form-error" className="mt-3 text-sm text-red-400">
          {error}
        </p>
      )}

      <button
        type="submit"
        data-testid="lead-form-submit"
        className="group mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-[hsl(var(--primary))] px-8 py-4 text-base font-semibold text-[hsl(var(--primary-fg))] transition-transform duration-300 hover:scale-[1.02]"
      >
        <Send size={17} className="transition-transform duration-300 group-hover:translate-x-0.5" />
        Send on WhatsApp
      </button>
    </form>
  );
};
